var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2889 1H15.2969L15.7969 6C15.7969 6 16.7969 7 18.2969 7C19.0843 7.00104 19.845 6.71441 20.4359 6.194C20.4983 6.13563 20.5449 6.0623 20.5711 5.98094C20.5974 5.89958 20.6024 5.81287 20.5859 5.729L19.8799 1.5C19.8563 1.36029 19.784 1.23345 19.6758 1.14194C19.5676 1.05042 19.4306 1.00014 19.2889 1V1Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2969 1L15.7969 6C15.7969 6 14.7969 7 13.2969 7C11.7969 7 10.7969 6 10.7969 6V1H15.2969Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 1V6C10.7969 6 9.79688 7 8.29688 7C6.79688 7 5.79688 6 5.79688 6L6.29688 1H10.7969Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29745 1H2.30645C2.16445 0.999947 2.02703 1.05026 1.91863 1.142C1.81023 1.23373 1.73789 1.36094 1.71445 1.501L1.00945 5.73C0.992977 5.81387 0.998099 5.90055 1.02434 5.98189C1.05058 6.06324 1.09707 6.13657 1.15945 6.195C1.48745 6.485 2.22045 7.001 3.29745 7.001C4.79745 7.001 5.79745 6.001 5.79745 6.001L6.29745 1.001V1Z",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80469 7V17C1.80469 17.5304 2.0154 18.0391 2.39047 18.4142C2.76555 18.7893 3.27425 19 3.80469 19H17.8047C18.3351 19 18.8438 18.7893 19.2189 18.4142C19.594 18.0391 19.8047 17.5304 19.8047 17V7",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6367 19V13C13.6367 12.4696 13.426 11.9609 13.0509 11.5858C12.6759 11.2107 12.1672 11 11.6367 11H9.63672C9.10629 11 8.59758 11.2107 8.2225 11.5858C7.84743 11.9609 7.63672 12.4696 7.63672 13V19",
    strokeWidth: 1.5,
    strokeMiterlimit: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreSettingIcon);
export default __webpack_public_path__ + "static/media/store-setting-icon.97c41ba6.svg";
export { ForwardRef as ReactComponent };